import { Button } from 'reactstrap';
import { FaFileExcel } from 'react-icons/fa';
import exportToSheet from 'utils/exportToSheet';

interface Planilha {
  codigo: string;
  descricao: string;
  quantidade: number;
  custoUnitario?: number | null;
  custoTotal?: number | null;
  mostrarCusto?: boolean;
}

interface Props {
  data: Planilha[];
  className?: string;
  isLoadingMateriais: boolean;
}

export function DownloadPlanilha({
  data,
  className,
  isLoadingMateriais,
}: Props): JSX.Element {
  const exportarPlanilha = () => {
    const mostrarCusto = data && data.length > 0 ? data[0].mostrarCusto : false;

    const materiaisAgrupados = (data || []).reduce((acc, item) => {
      const { codigo, descricao, quantidade, custoUnitario, custoTotal } = item;

      if (!acc[codigo]) {
        acc[codigo] = {
          codigo,
          material: descricao,
          quantidade,
          ...(mostrarCusto
            ? {
                custoUnitario: custoUnitario ?? 0,
                custoTotal: custoTotal ?? 0,
              }
            : {}),
        };
      } else {
        acc[codigo].quantidade += quantidade;
        if (mostrarCusto) {
          acc[codigo].custoTotal =
            (acc[codigo].custoTotal || 0) + (custoTotal ?? 0);
        }
      }

      return acc;
    }, {} as Record<string, { codigo: string; material: string; quantidade: number; custoUnitario?: number; custoTotal?: number }>);

    const totalCustoVal = mostrarCusto
      ? Object.values(materiaisAgrupados).reduce(
          (sum, item) => sum + (item.custoTotal ?? 0),
          0,
        )
      : 0;

    const dadosPlanilha = [
      {
        codigo: '',
        material: '',
        quantidade: '',
        ...(mostrarCusto ? { custoUnitario: '', custoTotal: '' } : {}),
      },
      ...Object.values(materiaisAgrupados),
      {
        codigo: 'Total',
        material: '',
        quantidade: '',
        ...(mostrarCusto
          ? {
              custoUnitario: '',
              custoTotal: totalCustoVal,
            }
          : {}),
      },
    ];

    const nomeArquivo = `MateriaisExcluidosExportados`;

    exportToSheet(dadosPlanilha, nomeArquivo);
  };

  return (
    <div className={className}>
      <Button
        size="sm"
        className="btn-icon btn-2"
        style={{ backgroundColor: '#1a8c5b' }}
        color="success"
        type="button"
        disabled={isLoadingMateriais}
        onClick={exportarPlanilha}
      >
        <FaFileExcel />
        <span className="btn-inner--text">Exportar materiais</span>
      </Button>
    </div>
  );
}
